<app-shared-filter
    [filter]="filter"
    (onChange)="onFilterChange($event)"
></app-shared-filter>

<table class="table">
    <thead>
        <tr>
            <!-- Colunas dinâmicas -->
            <th scope="col" *ngFor="let column of columns">
                {{ column }}
            </th>
        </tr>
    </thead>
    <tbody *ngIf="statusCode == 0">
        <tr *ngFor="let player of classif">
            <td>
                <div class="ranking-image">
                    <img src="{{ player.url_avatar }}" width="60px" />
                </div>
                <div class="ranking-info">
                    <span
                        ><strong>{{ player.nome }}</strong></span
                    >
                </div>
            </td>
            <td>{{ player.ranking }}º</td>
            <td>{{ player.ranking_externo }}º</td>
        </tr>
    </tbody>

    <!-- Mostrar mensagem -->
    <tbody *ngIf="statusCode > 0">
        <tr>
            <td>
                <h2 class="not-found">
                    Ops!
                    <br />
                    <span>{{ message }}</span>
                </h2>
            </td>
        </tr>
    </tbody>
</table>
